<h2 mat-dialog-title>Edit Attribute</h2>

<mat-card-content>
  <div fxLayout="column" fxLayoutGap="16px">
    <div [formGroup]="metaForm" fxLayout="column" fxLayoutGap="16px">
      <div fxLayout="row" fxLayoutGap="16px" fxLayout.lt-sm="column">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Name</mat-label>
          <input matInput formControlName="printAttributeName" />
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Attribute Type</mat-label>
          <input matInput formControlName="printAttributeType" />
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="16px" fxLayout.lt-sm="column">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Event Type</mat-label>
          <input matInput formControlName="eventTypeNames" />
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Division</mat-label>
          <input matInput formControlName="divisionNames" />
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" rows="2"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label>Version(s)</mat-label>
        <input matInput formControlName="versions" />
      </mat-form-field>
    </div>

    <div
      *ngIf="dynamicFields.length"
      fxLayout="column"
      fxLayoutGap="12px"
      [formGroup]="customFieldsForm"
    >
      <span class="mat-caption">Attribute Data</span>
      <ng-container *ngFor="let field of dynamicFields">
        <mat-form-field *ngIf="field.type === 'date'" appearance="outline" fxFlex="100">
          <mat-label>{{ field.label }}</mat-label>
          <input matInput [matDatepicker]="picker" [formControlName]="field.id" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field *ngIf="field.type === 'textarea'" appearance="outline" fxFlex="100">
          <mat-label>{{ field.label }}</mat-label>
          <textarea
            matInput
            [formControlName]="field.id"
            rows="3"
            [placeholder]="field.placeholder || ''"
          ></textarea>
        </mat-form-field>

        <mat-form-field
          *ngIf="field.type !== 'date' && field.type !== 'textarea'"
          appearance="outline"
          fxFlex="100"
        >
          <mat-label>{{ field.label }}</mat-label>
          <input
            matInput
            [type]="field.type === 'number' ? 'number' : 'text'"
            [formControlName]="field.id"
            [placeholder]="field.placeholder || ''"
          />
        </mat-form-field>
      </ng-container>
    </div>

    <p *ngIf="!dynamicFields.length" class="mat-caption">
      No dynamic fields are configured for this attribute type.
    </p>
  </div>
</mat-card-content>

<mat-dialog-actions align="end">
  <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
  <button type="button" mat-raised-button color="accent" (click)="save()">
    Save
  </button>
</mat-dialog-actions>
